import { render } from "./Advertisement.vue?vue&type=template&id=6cf8afc6&scoped=true"
import script from "./Advertisement.vue?vue&type=script&lang=js"
export * from "./Advertisement.vue?vue&type=script&lang=js"

import "./Advertisement.vue?vue&type=style&index=0&id=6cf8afc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf8afc6"]])

export default __exports__